import React from 'react';
import { Link } from '@mui/material';

const DSList = (props: React.ComponentProps<typeof Link>) => {
  return <Link color="primary" {...props} />;
};

export default DSList;
